export default __webpack_public_path__ + "images/f79bcd2efcc861840542cfeb96728874-hannukuh.jpg";